import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { ProFormDigit } from '@ant-design/pro-components';
import React from 'react';
export var calculateDigit = function calculateDigit(text, properties0) {
  var _properties0$fieldPro;
  // -
  var factor = Math.pow(10, ((_properties0$fieldPro = properties0.fieldProps) === null || _properties0$fieldPro === void 0 ? void 0 : _properties0$fieldPro.precision) || 2);
  // -
  if (properties0.mode == 'read') {
    return text / factor;
  } else {
    return Number((text * factor).toFixed(0));
  }
};
export var withMode = function withMode(properties0, mode) {
  return _objectSpread(_objectSpread({}, properties0), {}, {
    mode: mode
  });
};
export var ProFormPreciseDigit = function ProFormPreciseDigit(properties) {
  return /*#__PURE__*/React.createElement(ProFormDigit, _extends({}, properties, {
    formItemProps: _objectSpread(_objectSpread({}, properties.formItemProps), {}, {
      getValueFromEvent: function getValueFromEvent(value) {
        return calculateDigit(value, withMode(properties, 'edit'));
      },
      getValueProps: function getValueProps(value) {
        if (value) {
          return {
            value: calculateDigit(value, withMode(properties, 'read'))
          };
        } else {
          return {};
        }
      }
    })
  }));
};